import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/shared/lib/bff/client";

export const stateKeys = {
  all: ["states"] as const,
  list: () => [...stateKeys.all, "list"] as const,
};

export async function fetchStates(): Promise<string[]> {
  return apiFetch<string[]>("/api/location/states");
}

export function useStates() {
  return useQuery({
    queryKey: stateKeys.list(),
    queryFn: fetchStates,
  });
}
